'use strict';

angular.module('export')
    .component('exportAutoDownload', {
        templateUrl: 'modules/export/components/download/template.html',
        controller: 'ExportAutoDownloadController',
    });
